Vivense.init['product'] = Vivense.init['product'] || [];

window.viveProductPage = window.viveProductPage || {};

Vivense.init['product'].push(function () {

    var form = $("#admin-product-rate-form");

    var blockUIOpts = {
        // message: '<i class="fa fa-spinner fa-spin" style="font-size:24px"></i>',
        message: '<div class="vivense-loading-icon"><img src="/img/page-loading-vivense-logo.svg"></div>',
        fadeIn: 150,
        fadeOut: 50,
        css : {
            border: 'none',
            backgroundColor: 'none'
        },
        overlayCSS : {
            backgroundColor: '#fff',
            opacity: 0.6,
            cursor: null,
            color: '#fff'
        }
    };


    window.viveProductPage.initAdminProductRateForm = function (){

        function readURL(input,previewImg) {
            if (input[0].files && input[0].files[0]) {
                var reader = new FileReader();
                reader.onload = function(e) {
                    previewImg.attr('src', e.target.result);
                    previewImg.show();
                }
                reader.readAsDataURL(input[0].files[0]);
            } else {
                previewImg.attr('src', '');
            }
        }

        $("#img-upload-input").change(function (){
            readURL($(this),$('#uploaded-image'));
        });

        $(".star-admin-rating").change(function (){
           if($(this).val() < 5){
               $(".optional-area").show();
           }
           else{
               $(".optional-area").hide();
           }
        });

        function validateForm(){

            if(form.find('input[name=rating]:checked').val() === undefined){
                Vivense.displayError("Ürüne bir puan verin!");
                return false;
            }
            else if(form.find('input[name=rating]:checked').val() < 5 && form.find('select[name=qualityIssuesType]').val() === ""){
                Vivense.displayError("Ürünle ilgili kalite sorunlarının neler olduğunu belirt!");
                return false;
            }
            else if(form.find('input[name=rating]:checked').val() < 5 && form.find('textarea[name="qualityIssueComment"]').val().trim() === ''){
                Vivense.displayError("Kalite sorunu ile ilgili yorumlarını yaz!");
                return false;
            }
            else if(form.find('input[name=rating]:checked').val() < 5 && form.find('input[name="media"]').val().trim() === ''){
                Vivense.displayError("Görsel ekleyin!");
                return false;
            }
            else if(form.find('input[name=rating]:checked').val() < 5 && form.find('input[name=qualityDecreasing]:checked').val() === undefined){
                Vivense.displayError("'Sizce son dönemlerde kalitede belirgin bir düşüklük var mı?' Sorusunu cevaplayın!");
                return false;
            }

            return true;
        }

        form.submit(function (e) {
            e.preventDefault();

            if(!validateForm()){
                return;
            }

            var formData = new FormData(this);
            $.ajax({
                url: "/ajax/product/adminProductRate.php",
                type: 'POST',
                data: formData,
                success: function (data) {
                    form.hide();
                    if(data.status){
                        $(".admin-rate-success").show();
                    }
                    else{
                        $(".admin-rate-error").children().html(data.msg);
                        $(".admin-rate-error").show();
                    }
                },
                error: function (){
                    form.hide();
                    $(".admin-rate-error").children().html("Sistemsel bir sorundan dolayı değerlendirme tamamlanamadı!");
                    $(".admin-rate-error").show();
                },
                cache: false,
                contentType: false,
                processData: false,
                beforeSend: function() {
                    form.block(blockUIOpts);
                },
                complete: function (){
                    form.unblock(blockUIOpts);
                }
            });
        });
    }


    window.viveProductPage.initAdminProductRateForm();
});